export default __webpack_public_path__ + "static/media/coming_soon.3af5d5b2.png";